<template>
  <Modal width="446" :value="modalDisplayed" @cancel="closeModal" :actionsBorder="borderActive">
    <template #title>
      <div v-if="step != maxSteps" class="v-dialog__title">{{ modalTitle }}</div>
    </template>
    <template #subtitle>
      <div v-if="step != maxSteps" class="auth-step-indicator">
        <div
          v-for="loopStep in maxSteps - 1"
          :class="step >= loopStep ? 'primary' : ''"
          :key="loopStep"
          class="auth-step-indicator__line"></div>
      </div>
      <div v-else class="finish-text-wrapper">
        <div class="finish-title">🎉</div>
        <div class="finish-subtitle">{{ $t("custom.drip_modal.success_title_thank_you") }}</div>
        <div class="finish-subtitle">{{ $t("custom.drip_modal.success_title_appreciate") }}</div>
      </div>
    </template>
    <template #default>
      <v-radio-group v-if="step != maxSteps" v-model="currentValue" class="modal-radio-group" hide-details row>
        <v-radio
          class="modal-radio"
          v-for="option in currentOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"></v-radio>
      </v-radio-group>
    </template>
    <template #actions>
      <v-btn v-if="step != maxSteps" @click="changeStep" :disabled="!currentValue" class="modal-confirm-button">{{
        $t("custom.drip_modal.continue")
      }}</v-btn>
      <v-btn v-else @click="changeStep" class="modal-confirm-button">{{ $t("custom.drip_modal.finish") }}</v-btn>
    </template>
  </Modal>
</template>

<script>
  import Modal from "@/components/custom/Modal.vue";
  export default {
    name: "DripModal",
    components: {
      Modal,
    },
    data() {
      return {
        step: 1,
        maxSteps: 4,
        currentValue: "",
        businessOptions: [
          {
            value: "Agency",
            label: this.$t("custom.drip_modal.business_model.agency"),
          },
          {
            value: "Affiliate",
            label: this.$t("custom.drip_modal.business_model.affiliate"),
          },
          {
            value: "Blogger/publisher",
            label: this.$t("custom.drip_modal.business_model.blogger"),
          },
          {
            value: "Coach/consultant",
            label: this.$t("custom.drip_modal.business_model.coach"),
          },
          {
            value: "Non-profit",
            label: this.$t("custom.drip_modal.business_model.non_profit"),
          },
          {
            value: "Ecommerce",
            label: this.$t("custom.drip_modal.business_model.ecommerce"),
          },
          {
            value: "Professional service provider",
            label: this.$t("custom.drip_modal.business_model.service"),
          },
          {
            value: "Other",
            label: this.$t("custom.drip_modal.business_model.other"),
          },
        ],
        experienceOptions: [
          {
            value: "Newbie",
            label: this.$t("custom.drip_modal.experience_landing.new"),
          },
          {
            value: "Intermediate",
            label: this.$t("custom.drip_modal.experience_landing.intermediate"),
          },
          {
            value: "Pro",
            label: this.$t("custom.drip_modal.experience_landing.pro"),
          },
        ],
        purposeOptions: [
          {
            value: "For the company I work for",
            label: this.$t("custom.drip_modal.purpose.company_work"),
          },
          {
            value: "For the company I manage",
            label: this.$t("custom.drip_modal.purpose.company_manage"),
          },
          {
            value: "For agency clients",
            label: this.$t("custom.drip_modal.purpose.client"),
          },
          {
            value: "I’m a freelancer",
            label: this.$t("custom.drip_modal.purpose.freelancer"),
          },
        ],
      };
    },
    methods: {
      changeStep() {
        if (this.step === 1) {
          this.drip.push([
            "identify",
            {
              email: this.$store.state.user.email,
              Business_model: this.currentValue,
            },
          ]);
        } else if (this.step === 2) {
          this.drip.push([
            "identify",
            {
              email: this.$store.state.user.email,
              Experience_level: this.currentValue,
            },
          ]);
        } else if (this.step === 3) {
          this.drip.push([
            "identify",
            {
              email: this.$store.state.user.email,
              Signup_purpose: this.currentValue,
            },
          ]);
        }
        this.currentValue = "";
        if (this.step < this.maxSteps) {
          this.step++;
        } else {
          this.closeModal();
        }
      },
      closeModal() {
        this.$store.commit("SET_DISPLAY_DRIP_SURVEY_MODAL", false);
      },
    },
    computed: {
      modalTitle() {
        if (this.step === 1) {
          return this.$t("custom.drip_modal.business_model_header");
        } else if (this.step === 2) {
          return this.$t("custom.drip_modal.experience_landing_header");
        } else {
          return this.$t("custom.drip_modal.purpose_header");
        }
      },
      currentOptions() {
        if (this.step === 1) {
          return this.businessOptions;
        } else if (this.step === 2) {
          return this.experienceOptions;
        } else {
          return this.purposeOptions;
        }
      },
      modalDisplayed() {
        return this.$store.state.displayDripSurveyModal;
      },
      borderActive() {
        return this.step != this.maxSteps;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@core/preset/preset/functions.scss";
  .v-dialog__title {
    text-align: center;
  }

  .finish-title {
    font-size: 58px;
    line-height: 52px;
    text-align: center;
    margin-bottom: 20px;
    margin-top: -18px;
  }

  .finish-subtitle {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }

  .finish-text-wrapper {
    margin-bottom: -8px;
  }

  .modal-radio-group {
    .modal-radio {
      width: 100%;
      border: 1px solid get-color("border");
      border-radius: 4px;
      padding: 12px;

      &.v-item--active {
        border-color: get-color("primary");
        background-color: get-color("primary-10-hover");
      }

      &:hover {
        border-color: get-color("primary");
      }

      &::v-deep {
        label {
          font-size: 14px;
          color: get-color("headline");
        }
      }
    }

    &::v-deep {
      .v-input--radio-group__input {
        gap: 16px;
      }
    }
  }

  .modal-confirm-button {
    width: 100%;
    background-color: get-color("primary") !important;
    border-radius: 4px;
    padding: 12px 24px;

    &::v-deep {
      span {
        color: get-color("same-white");
      }
    }
  }

  .auth-step-indicator {
    display: flex;
    gap: 20px;
    margin: 20px 0 24px 0;
    &__line {
      height: 5px;
      border-radius: 4px;
      background: get-color("element-bg-300");
      flex: 1;
    }
  }
</style>
